import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';

import useRegister from './useRegister';
import AuthLayout from './AuthLayout';
import AuthForm from './AuthForm';
import InputPassword from '@components/controls/InputPassword';
import MediaIcon from '@assets/img/auth-media.svg';
import MailIcon from '@assets/img/input-mail.svg';

function RegisterPage(props) {
  const { t } = useTranslation();
  const { onSubmit } = useRegister();

  return (
    <AuthLayout
      className="register-page"
      title={
        <>
          {t('finish-register')}
          <br /> VBLite
        </>
      }
      icon={<MediaIcon width={215} height={160} />}
    >
      <AuthForm
        name="register"
        submitLabel={t('register')}
        onSubmit={onSubmit}
        initialValues={{ email: '' }}
      >
        <Form.Item
          className="auth-form__item"
          name="email"
          rules={[{ required: true, message: t('fill-your-email') }]}
        >
          <Input
            prefix={<MailIcon width={18} height={18} />}
            placeholder={t('email-placeholder')}
          />
        </Form.Item>
        <Form.Item className="auth-form__item" name="password">
          <InputPassword placeholder={t('password-placeholder')} />
        </Form.Item>
      </AuthForm>
    </AuthLayout>
  );
}

export default RegisterPage;
